<template>
  <div>
    <el-dialog :before-close="close" width="500px" center :visible="true">
      <template slot="title">
        <!-- 上报 -->
        <div v-if="type == '2'">
          <div>
            <span style="font-size: 20px"
              ><b>{{ codeText ? codeText : "短信验证码" }}</b></span
            >
          </div>
          <div>
            <span style="color: orangered;font-size: 20px"
              >[ {{ ` 至${fatherOrgName} ` }} ]</span
            >
          </div>
        </div>
        <!-- 审批 - 通过-->
        <div v-if="type == '0'">
          <div>
            <span style="font-size: 20px"><b>手机验证确认审批</b></span
            ><span style="color: orangered;font-size: 18px">[ 通过 ]</span>
          </div>
        </div>
        <!-- 审批 - 退回-->
        <div v-if="type == '1'">
          <div>
            <span style="font-size: 20px"><b>手机验证确认审批</b></span
            ><span style="color: orangered;font-size: 18px">[ 退回 ]</span>
          </div>
        </div>
      </template>
      <div class="elForm">
        <el-form ref="ruleForm" :rules="rules" :model="ruleForm">
          <el-form-item prop="phone">
            <el-input
              disabled
              prefix-icon="el-icon-user"
              v-model="ruleForm.phone"
              placeholder="手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input
              type="text"
              prefix-icon="el-icon-lock"
              placeholder="验证码"
              v-model="ruleForm.code"
            >
              <template slot="append">
                <div @click="handleGetSms" class="pointer">
                  {{ codeTxt }}
                </div>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="close()">取 消</el-button>
        <el-button type="primary" @click="doParentEvent()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "verifyCode.vue",
  data() {
    return {
      fatherOrgName: "",
      sendTime: 0,
      codeTxt: "获取短信验证码",
      codeFlag: false,
      codeCount: 60,
      ruleForm: {
        phone: "",
        code: "",
      },
      rules: {
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  props: [
    "codeText",
    "unit_name",
    "type",
    "verifyCodeDialog",
    "parentVerifyCode",
    "parentPhoneNumber",
  ],
  created() {
    this.ruleForm.phone = this.userInfo.phone;
    this.handleGetFather();
  },
  methods: {
    close() {
      this.$parent[this.verifyCodeDialog] = false;
    },

    async doParentEvent() {
      // 后台允许验证码输入上报成功后依然有效
      if (this.ruleForm.code == "" || this.$parent[this.verifyCode] == "") {
        this.$notify({
          title: "温馨提示",
          message: "您尚未获得或者未输入验证码，请获取验证码再操作。",
          type: "error",
          position: "bottom-right",
        });
        return false;
      }
      if (!/^[0-9]{6}$/.test(this.ruleForm.code)) {
        this.$notify({
          title: "温馨提示",
          message: "输入的验证码格式有误，请确认。",
          type: "error",
          position: "bottom-right",
        });
        this.ruleForm.code = "";
        return false;
      }
      // 如果为上报操作，进行验证码判断
      if (this.type == "2") {
        await this.$api
          .checkVerifyCode({
            code: this.ruleForm.code,
            phone: this.ruleForm.phone,
          })
          .then((res) => {
            if (res.error_no != 0) {
              this.$notify({
                title: "提示：",
                message: res.error_msg,
                position: "bottom-right",
                type: "error",
              });
              this.$parent[this.verifyCodeDialog] = false;
              return false;
            }
          });
      }
      this.$parent[this.parentPhoneNumber] = this.ruleForm.phone;
      this.$parent[this.parentVerifyCode] = this.ruleForm.code;
      this.$parent[this.verifyCodeDialog] = false;
      this.$emit("parentEvent");
    },

    handleGetSms() {
      if (this.codeFlag) {
        return false;
      }

      if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.ruleForm.phone)) {
        this.$notify({
          title: "失败",
          message: "手机号格式不对，请重新输入。",
          type: "error",
          position: "bottom-right",
        });
        return false;
      }
      let type = this.type;
      // 审批通过或退回都传 0
      if (type !== 2) {
        type = 0;
      }
      this.$api
        .sendSms({
          type: type,
          phone: this.ruleForm.phone,
        })
        .then((res) => {
          if (res.error_no === 0) {
            this.$notify({
              title: "温馨提示",
              message: "短信验证码发送成功",
              type: "success",
              position: "bottom-right",
            });
            this.sendTime += 1;
            this.handleCodeCountSub();
            this.codeFlag = true;
          } else {
            if (res.error_msg == "之前验证码还在有效期") {
              this.sendTime += 1;
            }
            this.$notify({
              title: "温馨提示",
              message: res.error_msg,
              type: "warning",
              position: "bottom-right",
            });
          }
        });
    },

    handleCodeCountSub() {
      let _self = this;
      _self.codeCount = 60;
      _self.codeTxt = _self.codeCount + "S";
      let a = setInterval(() => {
        _self.codeCount--;
        if (_self.codeCount === 0) {
          _self.codeTxt = "获取短信验证码";
          _self.codeFlag = false;
          clearInterval(a);
        } else {
          _self.codeTxt = _self.codeCount + "S";
        }
      }, 1000);
    },
    handleGetFather() {
      this.$api
        .getFatherOrg({
          params: {
            org_id: this.unitInfo.id,
          },
        })
        .then((res) => {
          this.fatherOrgName = res.data.name;
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-form >>> .el-input.is-disabled .el-input__inner {
  color:#606026
}
.elForm
  padding 0px 40px 0px 40px
</style>
